import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Container } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { CustomInput } from "../../MaintenanceReminders/MaintenanceRemindersForm";
import {
  getDateFnsLocale,
  getDisplayDate,
  uploadDocToS3,
} from "../../../../shared/helpers";
import { useTranslation } from "react-i18next";
import {
  ActionIconContainer,
  CustomLoader,
  FilterButton,
  GreenButton,
} from "../../../../shared/components/TableElements";
import {
  FormContainer,
  FormGroupLabel,
} from "../../../../shared/components/form/FormElements";
import { colorLightGray } from "../../../../utils/palette";
import getUnixTime from "date-fns/getUnixTime";
import { useSelector } from "react-redux";
import { updateUsersList } from "../../../../features/users/usersSlice";
import { useDispatch } from "react-redux";
import { addMsg } from "../../../../features/snackbar/snackbarSlice";
import { getUsers, postApi } from "../../../../api/getUser";
import { useAuth } from "../../../../contexts/AuthContext";

const MarkDocumentRenewedPopup = ({
  showPopup,
  setShowPopup,
  rowData,
  setShowDocRenewalFormPopup,
  setShowErrPopup,
}) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { setReload } = useAuth();
  const usersList = useSelector((state) => state.users.list);

  const [newExpiryDate, setNewExpiryDate] = useState(null);
  const [file, setFile] = useState(null);
  const [saveBtnLoading, setSaveBtnLoading] = useState(false);

  //const [filePreview, setFilePreview] = useState(null);

  const fileInputRef = React.useRef(null);

  console.log("file", file);

  const handleClose = () => {
    setNewExpiryDate(null);
    setFile(null);
    setShowPopup(false);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const previewUrl = URL.createObjectURL(selectedFile);
      //setFilePreview(previewUrl);
      setFile(selectedFile);
    } else {
      setFile(null);
    }
  };

  const handleConfirmRenewal = async () => {
    try {
      setSaveBtnLoading(true);
      const {
        doc_renewal_id,
        document_name,
        s3_url,
        driver_visible,
        user_id,
        start_date,
        due_on_date,
        emails,
        days_threshold,
        notes,
        org_id,
      } = rowData;

      const dueOnDateVal = newExpiryDate ? getUnixTime(newExpiryDate) : 0;

      let startDate = rowData.start_date;

      if (+rowData.due_on_date !== +dueOnDateVal) {
        startDate = getUnixTime(new Date());
      }

      let s3Url = document.url;
      if (file) {
        const fileExtension = file.name.split(".").pop();
        s3Url = `user_${user_id}/Documents/${document_name}.${fileExtension}`;
      }

      const docRenewals = [
        {
          doc_renewal_id: doc_renewal_id,
          user_id: user_id,
          document_name: document_name,
          due_on_date: dueOnDateVal,
          days_threshold: days_threshold,
          emails: emails || "",
          notes: notes || "",
          s3_url: s3Url || "",
          action: 2,
          start_date: startDate,
          driver_visible: driver_visible,
        },
      ];
      const docRenewalApiData = {
        source: "web",
        querystring: "add-document-renewal",
        doc_renewals: docRenewals,
      };

      const docRenewalRes = await postApi(docRenewalApiData, "commonNew");

      if (!docRenewalRes.success) {
        setSaveBtnLoading(false);
        setShowErrPopup(true);
        setShowPopup(false);
        return;
      }

      if (docRenewalRes.success) {
        const snackbarMsg = t("record_edited_msg", {
          recordName: t("user_renewal"),
        });

        if (!file) {
          dispatch(addMsg(snackbarMsg));
          setReload("documentrenewals");
          if (setShowDocRenewalFormPopup) {
            setShowDocRenewalFormPopup(false);
          }
          setSaveBtnLoading(false);
          setShowPopup(false);
          //setSnackbarMsg(snackbarMsg);
        }

        //If a new file has been uploaded, upload it to S3
        if (file) {
          const fileExtension = file.name.split(".").pop();

          const s3Doc = {
            file: file,
            key: `image_data/org_${org_id}/user_${user_id}/Documents/${document_name}.${fileExtension}`,
          };

          const status = await uploadDocToS3(s3Doc);
          if (status === 200) {
            //If new file extension is different from the one in user additonal docs,
            //then update user additional docs with the new extension
            const currentUser = usersList.find(
              (user) => user.user_id === user_id
            );

            if (currentUser.additional_documents) {
              const userDocsObj = JSON.parse(currentUser.additional_documents);
              const allDocsArr = userDocsObj["All_Documents"];
              if (allDocsArr.length > 0) {
                for (let doc of allDocsArr) {
                  const [[key, value]] = Object.entries(doc);
                  const { items, image, visible } = value;

                  if (
                    key?.toLocaleLowerCase() ===
                    document_name?.toLocaleLowerCase()
                  ) {
                    //Update updated date in the items array
                    let updatedItems = items.map((item) => {
                      if (item.title === "Updated date") {
                        return {
                          title: "Updated date",
                          author: getDisplayDate(getUnixTime(new Date())),
                        };
                      } else {
                        return item;
                      }
                    });
                    const newDoc = {
                      [key]: {
                        items: updatedItems,
                        image: [fileExtension],
                        visible: visible,
                      },
                    };
                    const updatedDocs = allDocsArr.map((doc) =>
                      doc[key] ? newDoc : doc
                    );
                    const updatedUserDocsObj = {
                      All_Documents: updatedDocs,
                    };
                    const updatedUserDocsStr =
                      JSON.stringify(updatedUserDocsObj);
                    const updateUserApiData = {
                      querystring: "update_user_additional_docs",
                      user_id: user_id,
                      additional_documents: updatedUserDocsStr,
                    };
                    const updateUserRes = await postApi(
                      updateUserApiData,
                      "commonNew"
                    );
                    if (updateUserRes?.success) {
                      const usersList = await getUsers();
                      dispatch(updateUsersList(usersList));
                    }
                  }
                }
              }
            }
          }
          dispatch(addMsg(snackbarMsg));
          setReload("documentrenewals");
          if (setShowDocRenewalFormPopup) {
            setShowDocRenewalFormPopup(false);
          }
          setSaveBtnLoading(false);
          setShowPopup(false);
        }
      }
    } catch (error) {
      setSaveBtnLoading(false);
      setShowErrPopup(true);
      setShowPopup(false);
      return;
    }
  };

  return (
    <Modal
      show={showPopup}
      onHide={handleClose}
      centered
      backdropClassName="custom-backdrop"
    >
      <Modal.Header>
        <h4>{t("mark_doc_as_renewed")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={handleClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body>
        <FormContainer>
          <Container>
            <p>{t("update_doc_status_msg")}</p>
            <Row>
              <Col>
                <FormGroupLabel>{t("new_expiry_date")}</FormGroupLabel>
                <div className="d-flex align-items-center">
                  <DatePicker
                    //minDate={new Date()}
                    minDate={(() => {
                      const tomorrow = new Date();
                      tomorrow.setDate(tomorrow.getDate() + 1);
                      return tomorrow;
                    })()}
                    selected={newExpiryDate}
                    onChange={setNewExpiryDate}
                    customInput={<CustomInput clearable={true} />}
                    placeholderText={t("date_tv")}
                    locale={getDateFnsLocale()}
                    dateFormat={"P"}
                    showMonthDropdown
                    showYearDropdown
                    isClearable
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <FormGroupLabel>{t("upload_new_doc")}</FormGroupLabel>
                <div className="d-flex align-items-center gap-1">
                  <FilterButton
                    type="button"
                    className="d-flex align-items-center gap-1"
                    onClick={() => fileInputRef.current.click()}
                  >
                    <i className="fi fi-rr-upload m-0 mt-1"></i>
                    <p>{t("choose_file")}</p>
                  </FilterButton>

                  {/* Hidden file input */}
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    accept="image/*,.doc,.docx, .pdf, application/msword"
                  />
                  {file && <div className="text-muted">{file.name}</div>}
                  {file && (
                    <div>
                      <ActionIconContainer onClick={() => setFile(null)}>
                        <i className="fi fi-rr-cross-small" />
                      </ActionIconContainer>
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            {file && (
              <Row>
                <Col>
                  <div
                    className="d-flex flex-column justify-content-center align-items-center p-2 my-2"
                    style={{
                      border: `1px solid ${colorLightGray}`,
                      borderRadius: "5px",
                    }}
                  >
                    <span>{t("preview")}</span>
                    {["png", "jpg", "jpeg", "jfif"].includes(
                      file.name.split(".")?.pop()
                    ) ? (
                      <img
                        src={URL.createObjectURL(file)}
                        alt="doc-photo"
                        width={300}
                        height={150}
                        id="doc"
                        style={{ objectFit: "cover" }}
                      />
                    ) : (
                      <iframe
                        src={URL.createObjectURL(file)}
                        alt="doc-photo"
                        width={300}
                        height={150}
                        id="doc"
                        //style={{ overflow: "hidden", height: "101%", width: "101%" }}
                      />
                    )}
                    {/* <HintText>{document.label}</HintText> */}
                  </div>
                </Col>
              </Row>
            )}
          </Container>
        </FormContainer>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <FilterButton type="button" onClick={handleClose}>
          {t("cancel")}
        </FilterButton>
        <GreenButton
          type="button"
          onClick={handleConfirmRenewal}
          disabled={!newExpiryDate}
        >
          {saveBtnLoading ? <CustomLoader /> : t("confirm_renewal")}
        </GreenButton>
      </Modal.Footer>
    </Modal>
  );
};

export default MarkDocumentRenewedPopup;
